module.exports = __webpack_public_path__ + "files/69bda582af6e789b6cded7a319287e14.png";